import React, { Fragment } from 'react';
import { Table, TableBody, Box, TableCell, TableContainer, TableHead, TableRow, Typography, Checkbox, Paper } from '@material-ui/core';
import { fieldValidate } from '../../../core/controls/helpers/checkers';
import { checkReferenceKey } from '../../../controls/jsons/attachments/conditionsbymodule';
import TextBox from '../../../core/controls/components/textbox';
import { getEnvVariable } from '../../environmentalList';

const Attachments = ({ selectedFile, validations, fileProgress, required = [], errorObj = {}, NoteView = [], handleFieldValue, referencekey }) => {
    const FormhandleFieldValue = (evt, index) => {
        const { name, value, checked } = evt.target;
        let error_Obj = {}
        error_Obj = fieldValidate(validations[name], value) || {};
        errorObj[name] = error_Obj;
        let temp = NoteView || [];
        if (temp.length === 0) {
            temp.push({ Notes: '', IsViewable: 'N', })
        }
        let obj = {
            'Notes': name === 'Notes' ? value : (temp && temp[index] && temp[index].Notes || ''),
            'IsViewable': name === 'IsViewable' ? (checked ? 'Y' : 'N') : (temp && temp[index] && temp[index].IsViewable || '')
        }
        let newtemp = { ...temp[index], ...obj }
        temp[index] = newtemp
        handleFieldValue({ data: temp, error: errorObj })
    }

    return (
        <Box>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><Typography variant="body2" style={{ fontWeight: 'bold' }}>Note</Typography></TableCell>
                            {getEnvVariable('AccessPortal') === 'I' && <TableCell><Typography variant="body2" style={{ fontWeight: 'bold' }}>Can be Viewed by Applicant?</Typography></TableCell>}
                            <TableCell><Typography variant="body2" style={{ fontWeight: 'bold' }}>File Names</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selectedFile && selectedFile.length > 0 && ([...Array(selectedFile.length).keys()] || []).map((file, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    <TextBox
                                        error={errorObj['Notes'] && errorObj['Notes'].error}
                                        helperText={errorObj['Notes'] && errorObj['Notes'].errorText}
                                        name="Notes"
                                        value={(NoteView && NoteView.length > 0 && NoteView[index] && NoteView[index].Notes) || ''}
                                        required={required.indexOf("Notes") > -1}
                                        multiline={true}
                                        handleFieldValue={(evt) => FormhandleFieldValue(evt, index)}
                                    />
                                </TableCell>
                                {getEnvVariable('AccessPortal') === 'I' && checkReferenceKey(referencekey) && (
                                    <TableCell>
                                        <Checkbox
                                            name="IsViewable"
                                            error={errorObj['IsViewable'] && errorObj['IsViewable'].error}
                                            helperText={errorObj['IsViewable'] && errorObj['IsViewable'].errorText}
                                            required={required.indexOf("IsViewable") > -1}
                                            value={(NoteView && NoteView.length > 0 && NoteView[index] && NoteView[index].IsViewable) || 'N'}
                                            labelPlacement="top"
                                            handleFieldValue={(evt) => FormhandleFieldValue(evt, index)}
                                        />
                                    </TableCell>
                                )}
                                <TableCell>
                                    <Typography variant="body2" color="textPrimary">
                                        {selectedFile[index].name}
                                        <br />
                                        {"Size: " + (selectedFile[index].size / 1048576).toFixed(2) + " MB"}
                                        {Array.isArray(fileProgress) && fileProgress.length > 0 && ` Progress %: ${fileProgress[index].progress}`}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default Attachments;